import { useEffect, useState } from 'react'
import { getProjectSalesVatsV2 } from '@/components/features/project-detail/quotes/quotes-v2.api'
import type { ProjectSalesVatsDto } from '@/components/features/project-detail/quotes/types'

export function useProjectSalesVatsV2(projectId: string | undefined) {
  const [data, setData] = useState<ProjectSalesVatsDto | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)

  useEffect(() => {
    if (!projectId) return

    let cancelled = false
    /* eslint-disable react-hooks/set-state-in-effect */
    setIsLoading(true)
    setError(null)
    /* eslint-enable react-hooks/set-state-in-effect */

    getProjectSalesVatsV2(projectId)
      .then((d) => {
        if (cancelled) return
        setData(d)
      })
      .catch((e) => {
        if (cancelled) return
        setError(e)
        setData(null)
      })
      .finally(() => {
        if (cancelled) return
        setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [projectId])

  return { data, isLoading, error }
}
